import { Question } from "../models/Questions";
import req from "axios";

export class CallMeData {
    public questions: Question[];
    public phoneType: string;
    public phone: string;

    constructor(questions: Question[], phoneType: string, phone: string) {
        this.phoneType = phoneType;
        this.phone = phone;
        this.questions = questions;
    }
}

export default function sendCallMeData(callMeData: CallMeData) {

    const qs = callMeData.questions.map(q => {
        return {
            text: q.text,
            answers: q.answers.filter(a => a.isChecked || a.isRange).map(a => a.isRange ? a.val : a.text)
        }
    });

    req.post('/src/call-me.php', {
        phoneType: callMeData.phoneType,
        phone: callMeData.phone,
        questions: qs
    });

}
